module.exports = __webpack_public_path__ + "img/Solutions-EstateAdministration.82369ac6.jpg";